import { api } from "../api";

/**
 * findAllVehiclesExportResponse - Function that finds on database all vehicles by status and then exports in a PDF/XSLX file  
 * /vehicles/{departmentId}/{status}/{exportType} 
 * method GET  
 * @async-function
 */
const findAllVehiclesExportResponse = async (token: string, customerId: number, departmentId: number, status: string, exportType: string, ignoreDepartments: boolean = false, simpleXlsxExport = false) => {
    const response = await api.get(
        `/vehicles/${customerId}/${departmentId}/${status}/${exportType}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllVehiclesExportResponse;